import { useNavigate, useLocation, useOutletContext } from 'react-router-dom'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { nextPage } from 'components/RCPro/helpers/nav'
import api from 'helpers/api'
import classNames from 'classnames'
import ResponseMessage from 'components/common/ResponseMessage/ResponseMessage'
import FirstName from 'components/RCPro/components/form/FirstName/FirstName'
import LastName from 'components/RCPro/components/form/LastName/LastName'
//import SelectCompany from 'components/RCPro/components/form/SelectCompany/SelectCompany'
import CompanyName from 'components/RCPro/components/form/CompanyName/CompanyName'
import CompanySiret from 'components/RCPro/components/form/CompanySiret/CompanySiret'
import CompanyAddress from 'components/RCPro/components/form/CompanyAddress/CompanyAddress'
import CompanyCity from 'components/RCPro/components/form/CompanyCity/CompanyCity'
import Activity from 'components/RCPro/components/form/Activity/Activity'
import Email from 'components/RCPro/components/form/Email/Email'
import PhoneNumber from 'components/RCPro/components/form/PhoneNumber/PhoneNumber'
import Select from 'components/common/Select/Select'
import Link from 'components/common/Link/Link'
import ArrowAlt from 'components/assets/icons/ArrowAlt'
import CircleOk from 'components/assets/icons/CircleOk'
import Button from 'components/common/Button/Button'
import { formParams } from 'constants/inputValidation'
import style from './Estimate.module.scss'
import SideForm from 'components/RCPro/components/SideForm/SideForm'
import Turnover from 'components/RCPro/components/form/Turnover/Turnover'

const RCProEstimate = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { state, pathname } = useLocation()
  const [ nextPageTransition ] = useOutletContext()
  const [ edit, setEdit ] = useState(false)
  const [ openBasket, setOpenBasket ] = useState(false)
  const [ errorMessage, setErrorMessage ] = useState(false)
  const {
    estimate,
    activity: { domains }
  } = state.texts

  const numberToPrice = (nb) => Number.parseFloat(nb).toFixed(2).replace('.',',')+" €"

  // Initialize form
  const {
    register,
    formState: { isValid, errors },
    handleSubmit,
    trigger,
    setValue,
    control,
    watch
  } = useForm({
    ...formParams,
    values: {
      firstname: state.firstname,
      lastname: state.lastname,
      //company: state.company,
      organizationName: state.organizationName,
      companyImmatriculation: state.companyImmatriculation,
      headquarterAddress: state.headquarterAddress,
      headquarterCity: state.headquarterCity,
      domain: state.domain,
      activity: state.activity,
      turnover: state.turnover,
      email: state.email,
      phone: state.phone
    },
  })

  const toggleEdit = () => {
    setEdit(!edit)
  }

  // const onCompanyChange = datas => {
  //   setValue('company', datas)
  //   trigger()
  // }

  const onDomainChange = datas => {
    const { sector } = domains.find( domain => domain.sector === datas )
    setValue('domain', sector)
    setValue('activity', '')
    trigger()
  }

  const onActivityChange = datas => {
    setValue('activity', datas)
    trigger()
  }

  const subscribe = () => {
    nextPage({ pathname, state, navigate })
    nextPageTransition()
  }

  const onSubmit = handleSubmit(async data => {
    setErrorMessage(false)
    try{
      const {
        firstname,
        lastname,
        organizationName,
        companyImmatriculation,
        headquarterAddress,
        headquarterCity,
        domain,
        turnover,
        activity,
        email,
        phone: { number }
      } = data

      const { sector, codeProduct } = domains.find( option => option.sector === domain )

      const resPrice = await api.get({
        url: `/rater/${codeProduct}/${turnover}/${activity}`,
        headers: {
          Authorization: `Bearer ${state.token}`
        }
      })

      if (resPrice.total_ttc){
        const price = (Number(resPrice.total_ttc) / 12).toFixed(2)
        const res = await api.patch({
          url: '/update-adhesions/client/'+state.adhesionId,
          data: {
            firstname,
            lastname,
            organizationName,
            companyImmatriculation,
            headquarterAddress,
            headquarterCity,
            sector,
            price,
            codeProduct,
            activity,
            turnover,
            email,
            phone: number
          },
          headers: { Authorization: `Bearer ${state.token}` },
        })
  
        if (res?.message) {
          navigate(pathname, { state: {
            ...state,
            ...data,
            price
          }})
          toggleEdit()
        } else {
          setErrorMessage(true)
        }
      } else {
        setErrorMessage(true)
      }
    } catch (error) {
      setErrorMessage(true)
      console.log('Failed to update adhesion')
    }
  })

  return (
    <>
      <span className={style.message}>
        <CircleOk />
        {estimate.success}
      </span>

      <span className={style.clear}></span>

      <aside className={classNames(style.basket, openBasket && style.open)}>
        <span className={style.toggle} onClick={() => setOpenBasket(!openBasket)}>
          <ArrowAlt />
        </span>
        <h2>{estimate.basketTitle} <span className={style.quantity}>(1)</span></h2>
        <div className={style.inside}>
          <ul>
            <li>
              <span>{estimate.productName}</span>
              <span>{numberToPrice(state.price)}</span>
            </li>
          </ul>
          <span className={style.total}>{numberToPrice(state.price)}/mois</span>
          <Button
            label={estimate.basketButton}
            onClick={subscribe}
            type="primary"
          />
        </div>
      </aside>

      <div className={style.estimate}>
        <h1 className={style.title}>{estimate.title}</h1>
        <p>
          <span dangerouslySetInnerHTML={{__html:
            estimate.resume
            .replace('{{activité}}', `<b>${state.activity}</b>`)
            .replace('{{CA}}', `<b>${state.turnover}</b>`)
          }}></span>
          &nbsp;
          <Link
            label={estimate.error}
            className={style.link}
            to={''}
            onClick={toggleEdit}
          />
        </p>

        <section className={style.product}>
          <h2>{estimate.productName}</h2>
          <p>{estimate.description}</p>
          <span className={style.price}>{numberToPrice(state.price)}/mois</span>

          <ul>
            {estimate.guarantees.map( (elm, index) => (
              <li key={`elm-${index}`}>
                <div dangerouslySetInnerHTML={{__html: elm.icon}}></div>
                <h3>{elm.title}</h3>
                <p>{elm.text}</p>
              </li>
            ))}
          </ul>
        </section>
      </div>


      <SideForm
        title={'Modifier vos réponses'}
        toggleEdit={toggleEdit}
        onSubmit={onSubmit}
        active={edit}
        content={
          <>
            <FirstName
              register={register}
              error={errors.firstname}
            />

            <LastName
              register={register}
              error={errors.lastname}
            />

            {/* <SelectCompany
              register={register}
              error={errors.company}
              onChange={onCompanyChange}
            /> */}

            <CompanyName
              register={register}
              error={errors.organizationName}
            />
            
            <CompanySiret
              register={register}
              error={errors.companyImmatriculation}
            />

            <CompanyAddress
              register={register}
              error={errors.headquarterAddress}
            />

            <CompanyCity
              register={register}
              error={errors.headquarterCity}
            />

            <Select
              options={domains.map( domain => ({
                label: domain.sector,
                value: domain.sector
              }))}
              onChange={val => onDomainChange(val.value)}
              label={t('mainReporting:form.domain.label')}
              placeholder={t('mainReporting:form.domain.placeholder')}
              value={watch('domain')}
              styles={{
                control:{
                  background: '#FFF'
                }
              }}
            />

            <Activity
              activities={domains.find( domain => domain.sector === watch('domain') ).activities}
              onChange={onActivityChange}
              value={watch('activity')}
            />

            <Turnover
              register={register}
              error={errors.turnover}
            />

            <Email
              register={register}
              error={errors.email}
            />

            <PhoneNumber
              control={control}
              error={errors.phone}
              value={state?.phone?.number || ''}
            />


            {errorMessage &&
              <ResponseMessage
                className={style.error}
                label={t('common:form.genericError')}
              />
            }

            <Button
              label={estimate.editButton}
              onClick={handleSubmit}
              disabled={!isValid}
              type="primary"
            />
          </>
        }
      />
    </>
  )
}

export default RCProEstimate